import has from 'lodash.has';
import impressionCache from './impressionCache';

import {
  SWAPS_NEW,
  SWAPS_NEW_REVIEW,
  SWAPS_NEW_ERROR,
  SWAPS_NEW_INELIGIBLE,
  SWAPS_NEW_CONFIRMATION,

  SWAPS,
  SWAPS_DETAIL,

  ACCOUNT_SWITCHER,

  RETURNS_HOME,
  RETURNS_LABEL,
  RETURNS_SELECT_DEVICE,
  RETURNS_SELECT_REASON,
  RETURNS_RETURN_METHODS,
  RETURNS_CONFIRMATION_XFINITY,
  RETURNS_CONFIRMATION_ID,
  RETURNS_ORDER_STATUS,
  RETURNS_ORDER_DETAIL,
  RETURNS_DOWNTIME,
} from './routes';

const baseDigitalData = {
  schemaVersion: 0.11,
  page: {
    category: {
      primaryCategory: 'myaccount',
      subCategory1: 'devices',
      businessType: 'resi',
      siteType: 'selfservice',
      designType: 'responsive',
    },
    codebase: {
      name: 'my account devices',
      releaseVersion: '11/05/2019',
    },
    affiliate: {
      channel: 'web',
      name: 'comcast',
    },
    pageInfo: {
      language: 'en',
      attributes: {
        experience: 'web',
      },
    },
    attributes: {},
  },
  siteInfo: {
    sessionID: Math.random().toString(36).substr(2, 9)
               + Math.random().toString(36).substr(2, 9), // just random string
    // visitorID: 'TODO - use value from item 2 below'
  },
  user: [
    {
      profile: [{
        profileInfo: {
          customerType: 'existing',
          authenticationType: 'active authenticated',
          recognizationType: 'cookie recognized',
        },
      }],
    },
  ],
};

/**
 * Log all DTM calls to console.
 * @param enabled
 *  A local flag, e.g., `const enabled = getConfig().REACT_APP_DTMLOG === 'TRUE'`
 * @constructor
 */
export const DTM2Console = (enabled = false) => {
  if (enabled === true) {
    window.trackingDebug = true;
  }
};

export const getTrackingData = (account = {}, macaroon = {}, lite = false) => {
  const digitalData = Object.assign({}, baseDigitalData);

  let currentUser;

  if (!account) {
    return digitalData;
  }

  // TODO: use macaroon with account role
  if (account.users && macaroon) {
    currentUser = account.users.find(user => user.guid === macaroon.guid);
  }

  if (account.fullAccountNumber) {
    digitalData.user[0].segment = {
      marketID: account.fullAccountNumber.substring(0, 8),
    };
  }

  if (account.accountGuid) {
    digitalData.user[0].profile[0].profileInfo = Object.assign({},
      digitalData.user[0].profile[0].profileInfo,
      {
        preActivationState: 'Active',
        authGUID: account.accountGuid,
        authenticationType: lite ? 'lite authenticated' : 'active authenticated',
      });
  }

  if (currentUser) {
    digitalData.user[0].profile[0].profileInfo = Object.assign({},
      digitalData.user[0].profile[0].profileInfo,
      {
        userGUID: currentUser.guid,
        type: (currentUser.role === 'PRIMARY') ? 'primary' : 'SECONDARY',
      });
  }

  return digitalData;
};

export const addComponent = component => impressionCache.add(component);
export const setComponent = (id, component) => impressionCache.set(id, component);
export const flushComponent = more => impressionCache.flush(more);

const swapsNewName = 'new swap';
const screenList = {
  [SWAPS]: 'swaps',
  [SWAPS_DETAIL]: 'swaps detail',

  [SWAPS_NEW]: swapsNewName,
  [SWAPS_NEW_ERROR]: 'error',
  [SWAPS_NEW_INELIGIBLE]: 'ineligible',
  [SWAPS_NEW_REVIEW]: 'review',
  [SWAPS_NEW_CONFIRMATION]: 'confirmation',

  [ACCOUNT_SWITCHER]: 'select account',

  [RETURNS_HOME]: 'entrance', // This happens if someone navigates to /returns
  [RETURNS_LABEL]: 'label image',
  [RETURNS_SELECT_DEVICE]: 'select device',
  [RETURNS_SELECT_REASON]: 'select reason',
  [RETURNS_RETURN_METHODS]: 'return methods',
  [RETURNS_CONFIRMATION_XFINITY]: 'return confirmation xfinity store',
  [RETURNS_CONFIRMATION_ID]: 'return confirmation ups',
  [RETURNS_ORDER_STATUS]: 'order status',
  [RETURNS_ORDER_DETAIL]: 'order detail',
  [RETURNS_DOWNTIME]: 'returns scheduled maintenance',
};

export const mapRouteToName = (match) => {
  if (!match || !match.path) {
    return false;
  }

  return screenList[match.override]
    || screenList[match.url]
    || screenList[match.path]
    || match.path;
};

const categoryList = {
  [SWAPS_DETAIL]: 'swaps',

  [SWAPS_NEW_ERROR]: swapsNewName,
  [SWAPS_NEW_INELIGIBLE]: swapsNewName,
  [SWAPS_NEW_REVIEW]: swapsNewName,
  [SWAPS_NEW_CONFIRMATION]: swapsNewName,
};

export const mapRouteToSubCategory = (match) => {
  if (!match || !match.path) {
    return false;
  }

  return categoryList[match.override] || categoryList[match.url] || categoryList[match.path];
};

export const getReturnConfirmationTrackingData = (returnData) => {
  const devices = has(returnData, 'returnInitiation.devices') ? returnData.returnInitiation.devices : [];

  const deviceList = devices.map(device => ({
    reason: device.returnReason,
    model: device.model,
    serialNumber: device.serialNumber,
  }));

  const deviceData = {
    transactionNumber: returnData && returnData.returnOrderId,
    method: returnData && returnData.returnInitiation.returnMethod,
    devices: deviceList,
  };

  return {
    user: [{
      profile: [{
        profileInfo: {
          device: {
            return: deviceData,
          },
        },
      }],
    }],
  };
};
